import type { ToastMessage } from '../shell/ToastHost.js';

export function showToast(text: string, tone: ToastMessage['tone'] = 'success'): void {
  window.dispatchEvent(new CustomEvent('mira:toast', { detail: { text, tone } }));
}
